import { Injector } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { DevelopmentSubstance } from "../../../Data/Art57Data/DevelopmentSubstance";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeSubstanceAttachmentFieldsList } from "../ListEntity/TreeNodeSubstanceAttachmentFieldsList";
import { TreeNodeSubstanceInternationalCodeList } from "../ListEntity/TreeNodeSubstanceInternationalCodeList";
import { TreeNodeSubstancePreviousNameCodeFieldsList } from "../ListEntity/TreeNodeSubstancePreviousNameCodeFieldsList";
import { TreeNodeSubstanceParentCodeFieldsList } from "../ListEntity/TreeNodeSubstanceParentCodeFieldsList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeDevelopmentSubstance extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new DevelopmentSubstance(
          new FieldDefinition(injector),
          new FormGroup({}),
          {}
        ),
        '{param1} - Development{param2}{param3}{param4}'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Development Substance';
      this.data.model.operationtype = 1;
    // localnumber is calculated in createchiltemplate of its parent because requires nodetype
    this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(lazy:boolean=true): void {
      const param1 = this.ioc!.get(LookupGetService).retrieveValueFromCache('operationtype',this.data.model.operationtype);
      let param3 = '';
      let param4 = '';
      const param2 = this.data.model && this.data.model.operationtype && this.data.model.operationtype === 1?'':'- ' + this.data.model.ev_Code;

      if (this.data && this.data.model && this.data.model.substancename) {
        param3 = ' - ' + this.data.model.substancename;
      }
  
      if (this.data && this.data.model && this.data.model.iscode) {
        param4 =
          ' - ' +
          this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'substancenameorcode',
            this.data.model.iscode
          );  
      }
  
      this.label = this.labelTemplate
        .replace('{param1}', param1)
        .replace('{param2}', param2)
        .replace('{param3}', param3)
        .replace('{param4}', param4);
    }
  
    override getMessage(): any {
      //Development substance level
      let developmentsubstance: any = {};
  
      if (this.data.model) {
        developmentsubstance = { ...this.data.model };
      }
  
      //Development substance children
      let childrenModel: any = {};
      this.children?.forEach((node) => {
        let developmentSubstanceChild = node as Art57Node;
        let art57Message = developmentSubstanceChild.getMessage();
        if (art57Message != null) {
          childrenModel = { ...childrenModel, ...art57Message };
        }
      });
  
      if (childrenModel) {
        developmentsubstance = { ...developmentsubstance, ...childrenModel };
      }
  
      return developmentsubstance;
    }

    override setMessage(jsonObject: any): void {

      super.setMessage(jsonObject);

      if (jsonObject.developmentsubstancenames && jsonObject.developmentsubstancenames.developmentsubstancename) {

        // FIXING code or name / name fields only can exist 1
        const developmentSubstanceName = jsonObject.developmentsubstancenames.developmentsubstancename.filter((item: any)=> {
              return item.preferred == 1;
        });

        if (developmentSubstanceName.length > 0) {
          Art57NodeUtils.generateFormlyModel(this.data.fields, developmentSubstanceName[0], this.data.model,'');
        }
      }

      // Import Children Nodes
      if (jsonObject.developmentsubstancenames && jsonObject.developmentsubstancenames.developmentsubstancename) {

        const developmentSubstanceItems = jsonObject.developmentsubstancenames.developmentsubstancename.filter((item: any)=> {
              return item.preferred == 2;
        });

        const developmentSubstanceJSON = {
          developmentsubstancenames: {
            developmentsubstancename: developmentSubstanceItems
          }
        };

        if (developmentSubstanceJSON) {
          Art57NodeUtils.importNodeType(this,developmentSubstanceJSON.developmentsubstancenames, 'developmentsubstancename',TreeNodeSubstancePreviousNameCodeFieldsList);
        }
      }

      if (jsonObject.internationalcodes && jsonObject.internationalcodes.internationalcode) {

        const internationalCodes = jsonObject.internationalcodes.internationalcode.filter((code: any) => {
          return code.referencetext && (code.referencetext.resolutionmode == null || code.referencetext.resolutionmode !== 2);
        });
        
        const internationalcodeJSON = {
          internationalcodes: {
            internationalcode: internationalCodes
          }
        };
        if (internationalcodeJSON) {
                  Art57NodeUtils.importNodeType(this,internationalcodeJSON.internationalcodes, 'internationalcode',TreeNodeSubstanceInternationalCodeList);
        }
      }
      
      if (jsonObject.internationalcodes && jsonObject.internationalcodes.internationalcode) {

        const substanceParentCodes = jsonObject.internationalcodes.internationalcode.filter((code: any) => {
          return code.referencetext && code.referencetext.resolutionmode == 2;
        });
        
        const substanceParentCodesJSON = {
          internationalcodes: {
            internationalcode: substanceParentCodes
          }
        };
        if (substanceParentCodesJSON) {
          Art57NodeUtils.importNodeType(this,substanceParentCodesJSON.internationalcodes, 'internationalcode',TreeNodeSubstanceParentCodeFieldsList);
        }
      }

      if (jsonObject.substanceattachments) {
         Art57NodeUtils.importNodeType(this,jsonObject.substanceattachments, 'substanceattachment',TreeNodeSubstanceAttachmentFieldsList);
      }

      this.refreshLabel();
        
    }
    
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.ev_Code
        ? this.data.model.ev_Code
        : '-',
        this.data.model &&
        this.data.model.operationtype &&
        this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationtype',
          this.data.model.operationtype
        ),
        this.data.model &&
        this.data.model.operationtype &&
        this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'substancestypes',
          this.data.model.type
        ),
        this.data.model && this.data.model.substancename
          ? this.data.model.substancename
          : '',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeDevelopmentSubstance =
        new TreeNodeDevelopmentSubstance(this.ioc!, newParent);
  
      const currentLocalNumber = this.ioc!.get(LookupGetService).getNodeLocalNumber(clonedNode, this);
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.data.model.localnumber = currentLocalNumber;
      this.ioc!.get(LookupGetService).fixLocalNumber(clonedNode.data.model.localnumber);

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];
      
      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }